export const SINGLE_MOSFET = {
	TAXONOMY_ID: 1000000,
	V_BR_DSS_MIN: 'V_BR_DSS_MIN',
	I_D_MAX: 'I_D_MAX',
	P_D_MAX: 'P_D_MAX',
	CHANNEL_POLARITY: 'CHANNEL_POLARITY',
	CONFIGURATION: 'CONFIGURATION',
	V_GS_MAX: 'V_GS_MAX',
	V_GS_TH_MAX: 'V_GS_TH_MAX',
	Q_GD_TYP_V_GS_4_5V: 'Q_GD_TYP_V_GS_4_5V',
	C_ISS_TYP: 'C_ISS_TYP',
	C_OSS_TYP: 'C_OSS_TYP',
	C_RSS_TYP: 'C_RSS_TYP',
	Q_RR_TYP: 'Q_RR_TYP',
	Q_G_TYP_VGS_10V: 'Q_G_TYP_VGS_10V',
	Q_G_TYP_VGS_4_5V: 'Q_G_TYP_VGS_4_5V',
	R_DS_ON_MAX_VGS_10V: 'R_DS_ON_MAX_VGS_10V',
	R_DS_ON_VGS_2_5V: 'R_DS_ON_VGS_2_5V',
	R_DS_ON_MAX_VGS_4_5V: 'R_DS_ON_MAX_VGS_4_5V',
	TECHNOLOGY: 'TECHNOLOGY',
	GATE_LEVEL: 'GATE_LEVEL',
	SILICON_FAMILY: 'SILICON_FAMILY',
	MOSFET_TYPE: 'MOSFET_TYPE',
	WIDE_SOA_MOSFET: 'WIDE_SOA_MOSFET',
	T_J: 'T_J'
};

export const ANALOG_BJT = {
	TAXONOMY_ID: 1000001,
	V_CE_SAT: 'V_CE_SAT',
	TYPE_OF_GENERAL_PURPOSE: 'TYPE_OF_GENERAL_PURPOSE',
	V_CBO: 'V_CBO',
	V_BE_ON: 'V_BE_ON',
	V_BE_SAT: 'V_BE_SAT',
	V_EBO: 'V_EBO',
	V_CEO_MIN: 'V_CEO_MIN',
	H_FE_MIN: 'H_FE_MIN',
	H_FE_MAX: 'H_FE_MAX',
	F_T_MIN: 'F_T_MIN',
	P_TM_MAX: 'P_TM_MAX',
	POLARITY: 'POLARITY',
	I_C_CONT: 'I_C_CONT',
	ANALOG_TRANSISTORS_GROUP: 'ANALOG_TRANSISTORS_GROUP'
};

export const POWER_SUPPLY = {
	TAXONOMY_ID: 1000004,
	POWER_CONVERSION: 'POWER_CONVERSION',
	OUTPUT_VOLTAGE_TYPE: 'OUTPUT_VOLTAGE_TYPE',
	V_O_MIN: 'V_O_MIN',
	V_O_MAX: 'V_O_MAX',
	V_I_MIN: 'V_I_MIN',
	V_I_MAX: 'V_I_MAX',
	I_O_TYP: 'I_O_TYP',
	TOPOLOGY: 'TOPOLOGY',
	CONTROL_MODE: 'CONTROL_MODE',
	F_SW_TYP: 'F_SW_TYP',
	I_Q_TYP: 'I_Q_TYP',
	V_CC_MIN: 'V_CC_MIN',
	V_CC_MAX: 'V_CC_MAX',
	UVLO: 'UVLO',
	STAND_BY_MODE: 'STAND_BY_MODE',
	DRIVE_CAPABILITY_SOURCE: 'DRIVE_CAPABILITY_SOURCE',
	DRIVE_CAPABILITY_SINK: 'DRIVE_CAPABILITY_SINK',
	LATCH: 'LATCH',
	SHUTDOWN_PIN: 'SHUTDOWN_PIN',
	EFFICIENCY: 'EFFICIENCY',
	PHASES: 'PHASES',
	V_DO_TYP: 'V_DO_TYP',
	PSRR: 'PSRR',
	NOISE: 'NOISE',
	APPLICATION: 'APPLICATION',
	POLARITY: 'POLARITY',
	OUTPUT: 'OUTPUT',
	ENABLE: 'ENABLE',
	POWER_GOOD: 'POWER_GOOD',
	SHORT_CIRCUIT_PROTECTION: 'SHORT_CIRCUIT_PROTECTION',
	SOFT_START: 'SOFT_START',
	F_JITTER_TYP: 'F_JITTER_TYP',
	R_DS_ON: 'R_DS_ON',
	V_BR_DSS: 'V_BR_DSS',
	I_PEAK: 'I_PEAK',
	HIGH_VOLTAGE_STARTUP: 'HIGH_VOLTAGE_STARTUP',
	DSS: 'DSS',
	OVER_POWER_COMPENSATION: 'OVER_POWER_COMPENSATION',
	BROWN_OUT: 'BROWN_OUT',
	PFC_MODE: 'PFC_MODE',
	FREQUENCY_OPERATION: 'FREQUENCY_OPERATION',
	UVP: 'UVP',
	INHIBITION: 'INHIBITION',
	V_REF_TYP: 'V_REF_TYP',
	TA_MAX: 'TA_MAX',
	TA_MIN: 'TA_MIN',
	POWER_SUPPLY_GROUP: 'POWER_SUPPLY_GROUP'
};
